import { RouteRecordRaw } from 'vue-router'

export const onboardingRoutes: Array<RouteRecordRaw> = [
  {
    path: '/onboarding/intro/start',
    name: 'OnboardingStart',
    component: () => import('@/views/onboarding/intro/StartPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/onboarding/intro/feature1',
    name: 'Feature1',
    component: () => import('@/views/onboarding/intro/Feature1Page.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/onboarding/intro/feature2',
    name: 'Feature2',
    component: () => import('@/views/onboarding/intro/Feature2Page.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/onboarding/intro/feature3',
    name: 'Feature3',
    component: () => import('@/views/onboarding/intro/Feature3Page.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/onboarding',
    redirect: '/onboarding/intro/start',
    meta: { requiresAuth: false },
  },
]
